import { Typography } from "@material-ui/core";
import React from "react";

interface TitleProps {
    text: string;
    className?: string;
    color?:
        | "inherit"
        | "initial"
        | "primary"
        | "secondary"
        | "textPrimary"
        | "textSecondary"
        | "error";
}

const Title: React.FC<TitleProps> = ({ text, className, color }) => (
    <Typography
        component="h2"
        variant="h6"
        className={className}
        color={color || "textPrimary"}
    >
        {text}
    </Typography>
);

export { Title };
